import { render, staticRenderFns } from "./gSearch.vue?vue&type=template&id=150b22ee&scoped=true&"
import script from "./gSearch.vue?vue&type=script&lang=js&"
export * from "./gSearch.vue?vue&type=script&lang=js&"
import style0 from "./gSearch.vue?vue&type=style&index=0&id=150b22ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b22ee",
  null
  
)

export default component.exports